import React from "react";
import { FmImage } from "@/ui-component";
import {
    changeColorImg,
    ColorItem,
    IInitedInfo,
    IProductDetailsInfo,
} from "@/store/modules/productDetails";
import { getProductMododelImgs } from "@/src/utils/assemblePdctSrc";
interface IProps {
    image: string;
    index: number;
    productImgListLength: number;
}
export function getBannerShowData(
    productDetail: Partial<IInitedInfo & IProductDetailsInfo>,
    activeObj: Partial<ColorItem>,
    t: any,
) {
    const { isSun } = productDetail;
    const productImgList = changeColorImg({
        productId: productDetail.products_id!,
        data: productDetail,
        index: activeObj?.index,
    });

    const modelImgList = getProductMododelImgs(
        productDetail?.products_id!.toString(), // 大胆点儿，肯定有
        "large",
        activeObj?.products_color_model,
        productDetail.products_model_show || [],
    );
    let list: any = [...productImgList, ...modelImgList];

    const sunGlasses =
        productDetail.products_frame == "Rimless"
            ? "common:IMAGE.SunGlassesFramelessColor"
            : "common:IMAGE.SunGlassesColor";
    isSun && list.push(t(sunGlasses));
    return { list, productImgList };
}
const BannerShow: React.FC<IProps> = (props) => {
    return (
        <div
            className={"default_layout"}
            style={{
                width: "100%",
                height: "5rem",
                overflow: "hidden",
            }}
        >
            <FmImage
                height={400}
                image={props.image}
                style={
                    props.index >= props.productImgListLength
                        ? {
                              height: "5rem",
                              width: "auto",
                              maxWidth: "unset",
                          }
                        : {}
                }
            />
        </div>
    );
};

export default BannerShow;
